import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replacechar'
})
export class ReplacecharPipe implements PipeTransform {

  transform(tag: string, bar: string, bar2: string): unknown {
    // console.log(tag.substr(tag.length-1,1));
    if(bar=='editor') {
      return tag.replace('؛', '؛ ').replace(':', ': ').replace('-', ' - ').replace('،', '').replace('  ', ' ');
    }
    else if(tag.substr(tag.length-1,1)==='،' || tag.substr(tag.length-1,1)===':' || tag.substr(tag.length-1,1)==='؛')
    {
      return tag.substr(0,tag.length-1).replace(bar, bar2).replace('  ', ' ');
    }
    else {
      return tag.replace(bar, bar2).replace('  ', ' ');
    }
  }

}
